module.exports = __webpack_public_path__ + "media/images/tabler-dark-2802f33821ba436ca0216bcf1ebb89cc.svg";